"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDPDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../../../utils/classNames");
const PDPDescription = ({ description }) => {
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", { className: (0, classNames_1.cn)('text-fluid-0', 'font-medium', 'aires-pdp-description'), suppressHydrationWarning: true, dangerouslySetInnerHTML: {
                __html: description,
            } }) }));
};
exports.PDPDescription = PDPDescription;
